import { BarChart, Bar, XAxis, YAxis, ResponsiveContainer, Cell } from 'recharts'
import type { NodeStatus } from '@/api/types'

interface NodeStatusChartProps {
  data: Record<NodeStatus, number>
}

const statusColors: Record<NodeStatus, string> = {
  Active: 'hsl(142.1 76.2% 36.3%)',
  Pending: 'hsl(47.9 95.8% 53.1%)',
  Blocked: 'hsl(0 84.2% 60.2%)',
  Rotating: 'hsl(221.2 83.2% 53.3%)',
  Offline: 'hsl(var(--muted-foreground))',
}

export function NodeStatusChart({ data }: NodeStatusChartProps) {
  const chartData = Object.entries(data)
    .filter(([_, count]) => count > 0)
    .map(([status, count]) => ({
      status,
      count,
      color: statusColors[status as NodeStatus],
    }))

  if (chartData.length === 0) {
    return (
      <div className="flex h-[200px] items-center justify-center text-muted-foreground">
        No nodes
      </div>
    )
  }

  return (
    <ResponsiveContainer width="100%" height={200}>
      <BarChart data={chartData} layout="vertical" margin={{ left: 20, right: 20 }}>
        <XAxis type="number" hide />
        <YAxis
          type="category"
          dataKey="status"
          axisLine={false}
          tickLine={false}
          className="text-sm fill-muted-foreground"
        />
        <Bar dataKey="count" radius={[0, 4, 4, 0]} barSize={24}>
          {chartData.map((entry, index) => (
            <Cell key={`cell-${index}`} fill={entry.color} />
          ))}
        </Bar>
      </BarChart>
    </ResponsiveContainer>
  )
}
